export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Export-Gray-05434b098dbe655939ed15a8051f685e.svg";